<template>
  <div class="MyReward">
    <my-header title="查看奖励" :platform="platform"></my-header>
    <!-- <div class="mr_top" v-html="reward_content.rewardDesc"></div> -->
    <div class="reward-top-box">
        <div class="reward-top">
            <div class="reward-top-left">
                <p  class="top-label" v-html="descList[0]"></p>
                <p class="top-sub-label" v-html="descList[2]"></p>
                <p class="top-sub-label" v-html="descList[3]"></p>
            </div>
            <div class="top-leaf">
                <p class="top-label">获得桉树叶</p>
                <p class="red-text">{{descList[1]}}</p>
            </div>
        </div>
    </div>
    <div class="mr_list">
      <div class="mrl_thead flex_sb">
        <div class="time">日期</div>
        <div class="status">状态</div>
        <div class="reward">奖励</div>
      </div>
      <div class="mrl_tbody">
        <div
          class="items flex_sb"
          v-for="(item, index) in reward_content.list"
          :key="index"
        >
          <div class="time">{{ item.uploadTime }}</div>
          <div class="status">{{ item.uploadState }}</div>
          <div class="reward">{{ item.giveCourseDesc }}</div>
        </div>
      </div>
    </div>
    <div class="mr_nomore"></div>
  </div>
</template>
<script>
import http from "../../../service/http";
import MyHeader from "../common/MyHeader/MyHeader"
export default {
  name: "MyReward",
  data() {
    return {
      ajaxurl:
        "https://apinew.koalaknow.com/api/OfficialWebSite/InterfaceV1",
      userinfo: {}, //用户的基本信息
      reward_content: [], //当前页面全部数据
        descList: [],
      platform:''
    };
    },
  components: {
    MyHeader
  },
  created() {
      document.title = "查看奖励";
    this.platform=this.$route.query.platform
  },
  mounted() {
    var userinfo = localStorage.getItem("userinfo");

    this.userinfo = JSON.parse(userinfo);

    var imgUrl = "https://www.koalaknow.com/img/VcharImg/vcharlogo.png"; // 分享图标
    var title = "为孩子报名",
      desc = "专业老师，专属课程，爱上“动起来”的中文";
    http.wxshare(
      this.userinfo.userId,
      "https://official.koalaknow.com/MyMission?uid=" + this.userinfo.userId,
      title,
      desc,
      imgUrl
    );

    this.getList();
  },
  methods: {
    getList() {
      $(".mr_nomore").text("正在加载...");
      var data = {
          cmd: "GetUserTaskRewardInfo",
          userGuid: this.userinfo.userGuid,
        },
        that = this;
      http.req(
        data,
        (res) => {
          that.reward_content = res;
            let descList=res.rewardDesc.split('；')
            descList[1]=descList[1].replace('桉树叶','')
            that.descList=descList
          if (res.list.length == 0) {
            $(".mr_nomore").text("暂无数据");
          } else {
            $(".mr_nomore").text("没有更多了");
          }
        },
        this.ajaxurl
      );
    },
  },
};
</script>
<style scoped>
.MyReward {
  min-height: 100vh;
  background: #f4f4f4;
}
.mr_top {
  color: #666666;
  font-size: 28px;
  line-height: 37px;
  text-align: center;
  background: #fff;
  padding: 40px 30px 30px;
  box-sizing: border-box;
}
.mr_top >>> span {
  color: #ff2424;
}
.reward-top-box{
    padding: 30px;
    padding-bottom: 0;  
}
.reward-top{
    background: #FFFFFF;
    border-radius: 20px;
    display: flex;
    justify-content: space-between;
    padding: 30px;
    padding-right: 0;
}
.reward-top-left >>>span{
    color: #F13834;
    font-weight: bold;
}

.top-sub-label{
    font-size: 28px;
    font-weight: 400;
    color: #333333;
}
.top-leaf{
    width: 268px;
    border-left: 2px solid #EEEEEE;
    padding-left: 30px;
    box-sizing: border-box;
}
.top-label{
    font-size: 36px;
    font-weight: 400;
    color: #333333;
    margin-bottom: 10px;
}
.red-text{
    font-size: 40px;
    font-weight: bold;
    color: #F13834;
}
.mr_list {
  padding: 35px 30px;
  padding-bottom: 0;
  box-sizing: border-box;
  text-align: center;
}
.mr_list .mrl_thead {
  height: 56px;
  background: #ffffff;
  line-height: 56px;
  font-size: 28px;
}
.mr_list .time {
  width: 180px;
}
.mr_list .status {
  width: 100px;
}
.mr_list .reward {
  text-align: right;
  flex: 1;
  -webkit-flex: 1;
  padding: 0 70px 0 0;
  box-sizing: border-box;
}
.mr_list .mrl_tbody {
  margin: 24px 0 0;
}
.mr_list .mrl_tbody .reward {
  padding: 0 30px 0 0;
  box-sizing: border-box;
}
.mr_list .items {
  padding: 14px 0;
  box-sizing: border-box;
  line-height: 31px;
  color: #666;
  font-size: 24px;
  border-bottom: 1px solid #cccccc;
}
.mr_nomore {
  color: #999;
  font-size: 24px;
  line-height: 86px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/content/MyReward.vue